<template>
    <div id="app" class="app-root" :class="['lang-'+$i18n.locale, device]">
        <!-- 应用级的单页 -->
        <div class="single-page" v-if="$route.meta.single">
            <router-view></router-view>
        </div>

        <!-- 学员框架页 -->
        <transition name="slide-fade">
            <app-student v-if="!$route.meta.single && userInfo.type === 3" :title="systemInfo.name"></app-student>
        </transition>

        <!-- 管理端框架页（admin、培训师） -->
        <transition name="slide-fade">
            <div class="app-manager" :class="appThemeClass" id="app-manager"
                 v-if="!$route.meta.single && userInfo.type !== 3">

                <app-header height="64px" :title="systemInfo.name"></app-header>

                <app-aside></app-aside>

                <div class="app-main">
                    <app-nav></app-nav>

                    <div class="app-main-inner">
                        <transition name="slide-fade">
                            <keep-alive>
                                <router-view v-if="$route.meta.keepAlive"></router-view>
                            </keep-alive>
                        </transition>
                        <transition name="slide-fade">
                            <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
                        </transition>
                    </div>
                </div>

                <global-uploader></global-uploader>
            </div>
        </transition>

        <!-- IE浏览器提示 -->
        <el-alert
            v-if="IENotice"
            class="ie-alert"
            title="浏览器版本过低"
            type="warning"
            description="您使用了IE浏览器，图像等部分功能不可用，请使用最新版Chrome以获得完整体验"
            show-icon>
        </el-alert>
    </div>
</template>

<script>
    import appHeader from '@/components/App/AppHeader.vue'
    import appAside from '@/components/App/AppAside.vue'
    import appNav from '@/components/App/AppNav.vue'
    import appStudent from '@/components/App/AppStudent.vue'
    import globalUploader from '@/components/GlobalUploader.vue'
    import {mapGetters} from 'vuex';
    import {Ticket} from '@/utils';

    export default {
        name: 'app',

        data() {
            return {
                device: '',
                IENotice: false,
                isRouterAlive: true
            }
        },

        computed: {
            //theme: 0新版暗色、1经典
            ...mapGetters([
                'appTheme',
                'systemInfo',
                'userInfo',
                'documentSize'
            ]),
            appThemeClass() {
                return ['app-theme1', 'app-theme2', 'app-theme3', 'app-theme4', 'app-theme5'][this.appTheme]
            },
        },

        created() {
            // 在有票的情况下，要初始化一些数据
            this.initApp()

            // ie的全局提示
            this.testIE()

            this.$store.commit('changeDocumentSize')
            this.onAppResize()

            // 把app实例挂接到window上
            window.APP_ROOT = this
        },

        watch: {
            documentSize(v) {
                let width = v.width

                if (width <= 768) {
                    this.device = 'mode-mobile'
                } else if (width <= 990) {
                    this.device = 'mode-pad'
                } else {
                    this.device = ''
                }
            }
        },

        methods: {
            initApp() {
                // 如果页面刷新（已登录），则重新拿这些数据
                const whiteList = ['/', '/login', '/hrlogin']
                if (whiteList.includes(location.pathname)) return

                if (Ticket.get()) {
                    this.$store.commit('initAppTheme');
                    this.$store.commit('initUserInfo');
                    this.$store.dispatch('getSystemInfo');
                    //console.log('用户信息', Ticket.get());
                }
            },

            testIE() {
                let isIE = (!!window.ActiveXObject || "ActiveXObject" in window);
                this.IENotice = isIE;
            },

            onAppResize() {
                window.addEventListener('resize',  () => {
                    this.$store.commit('changeDocumentSize')
                })
            },

            // 全局的刷新页面方法 window.APP_ROOT.reload
            reload () {
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            }
        },

        components: {
            appHeader,
            appAside,
            appNav,
            appStudent,
            globalUploader
        }
    }
</script>

<style lang="scss">
    @import './style/index.scss';

    .single-page {
        height: 100%;
    }

    .app-manager {
        height: 100%;
    }

    .app-main {
        position: relative;
        height: 100%;
        padding-top: $h-header + $h-nav;
        overflow: auto;

        // 内容区，滚动条在这里
        .app-main-inner {
            /*
            ** 2019/9/26 去掉最小宽度，优化小屏体验
            */
            //min-width: 1367px - $w-aside - 10;
            height: 100%;
            position: relative;
            overflow: auto;
            z-index: 11; // app-nav: 10
        }
        .app-inner-overflow {
            overflow: hidden;
        }
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-enter {
        transform: translateX(10);
        opacity: 0;
    }

    /*更改首页 popover 样式*/
    .login-pop {
        padding: 4px;
        min-width: 80px;
    }

    .ie-alert {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1000;
    }
</style>
